
import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2, Download } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export interface Attachment {
  id: string;
  filename: string;
  mimetype: string;
  size: number;
  storage_path: string;
  created_at: string;
}

interface AttachmentCardProps {
  attachment: Attachment;
  onDelete: (id: string) => void;
  isCreator?: boolean;
}

export const AttachmentCard: React.FC<AttachmentCardProps> = ({
  attachment,
  onDelete,
  isCreator = false,
}) => {
  const fileUrl = supabase.storage.from("entry_attachments").getPublicUrl(attachment.storage_path).data.publicUrl;

  const isImage = (mimetype: string) =>
    mimetype.startsWith("image/");

  return (
    <div className="flex items-center gap-4 p-2 border rounded-md bg-muted/30">
      <div className="flex-shrink-0 w-14 h-14 rounded-md bg-white flex items-center justify-center overflow-hidden">
        {isImage(attachment.mimetype) ? (
          <img
            src={fileUrl}
            alt={attachment.filename}
            className="object-contain w-full h-full"
          />
        ) : (
          <span className="text-xs">{attachment.filename.split('.').pop()?.toUpperCase()}</span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-medium truncate">{attachment.filename}</div>
        <div className="text-xs text-muted-foreground">
          {(attachment.size / 1024).toFixed(1)} KB
        </div>
        <div className="text-xs text-muted-foreground">
          {new Date(attachment.created_at).toLocaleString()}
        </div>
      </div>
      <div className="flex gap-1">
        <Button
          asChild
          size="icon"
          variant="ghost"
        >
          <a href={fileUrl} download title="Download">
            <Download className="h-4 w-4" />
          </a>
        </Button>
        {isCreator && (
          <Button
            size="icon"
            variant="destructive"
            title="Delete"
            onClick={() => onDelete(attachment.id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
